module.exports = __webpack_public_path__ + "static/media/meeting.59390c7c.png";